<template>
  <section class="card">
    <link rel="stylesheet" type="text/css" href="/css/dashboard.css">
    <header class="card-header main-header p-3">
      <div class="row h-100">
        <div class="col-lg-4">
          <h2 class="card-title mb-title-2">
            Extrato do fornecedor
          </h2>
        </div>
        <div class="col-lg-8">
          <div class="form-row">
            <div class="form-group col-lg-5 mb-0">
              <v-select v-model="fornecedor"
                        :filterable="false"
                        @search="buscarFornecedor"
                        :options="fornecedores"
                        label="Nome"
                        placeholder="Digite para consultar o fornecedor"
                        append-to-body
                        @input="onFornecedorInput"><span slot="no-options">Busca não encontrada</span></v-select>
            </div>
            <div class="form-group col-lg-3 mb-0">
              <select class="form-control form-control-sm" v-model="range" @change="changeRange">
                <option v-for="r in dtRange" :value="r.value" :key="r.id">{{r.id}}</option>
              </select>
            </div>
            <div class="form-group col-lg-2 mb-0">
              <input type="date"
                     class="form-control form-control-sm"
                     id="inicio"
                     v-model="inicio"
                     @change="changeTextRange" />
            </div>
            <div class="form-group col-lg-2 mb-0">
              <input type="date"
                     class="form-control form-control-sm"
                     v-model="fim"
                     :min="inicio"
                     @change="changeTextRange" />
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="p-4">
      <h4 class="text-center text-muted" v-if="!fornecedor">
        Selecione um fornecedor para ver o extrato do período.
      </h4>

      <template v-if="fornecedor">
        <h4 class="text-center text-muted" v-if="consultado && !data.length">
          Nenhuma despesa encontrada para este fornecedor no período selecionado.
        </h4>

        <template v-if="data.length">
        <div class="row">
          <div class="col-lg-6">
            <section class="card">
              <div class="card-body">
                <div id="containerFornecedorClassificacao"></div>
              </div>
            </section>
          </div>
          <div class="col-lg-6">
            <section class="card">
              <header class="card-header">
                <h2 class="card-title">Qualidade da entrega</h2>
                <p class="card-subtitle">Considera as despesas enviadas ao fornecedor no período</p>
              </header>
              <div class="card-body">
                <p class="mb-3">
                  Neste período foram enviados <b>{{ qualidade.chassis }}</b> chassi(s) com
                  <b>{{ qualidade.requisicoes }}</b> requisiç(ões), sendo
                  <b class="text-success">{{ qualidade.noPrazo }}</b> no prazo e
                  <b class="text-danger">{{ qualidade.atrasadas }}</b> com atraso na entrega.
                </p>
                <table class="table table-sm table-bordered mb-0">
                  <tbody>
                    <tr>
                      <th>Entregues no prazo</th>
                      <td>{{ qualidade.entreguesNoPrazo }}</td>
                      <th>Entregues com atraso</th>
                      <td>{{ qualidade.entreguesComAtraso }}</td>
                    </tr>
                    <tr>
                      <th>Em andamento no prazo</th>
                      <td>{{ qualidade.emAndamentoNoPrazo }}</td>
                      <th>Em andamento atrasadas</th>
                      <td>{{ qualidade.emAtraso }}</td>
                    </tr>
                    <tr>
                      <th>% de atraso</th>
                      <td colspan="3"><b>{{ qualidade.percentualAtraso }}%</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col-lg-12">
            <section class="card">
              <header class="card-header">
                <div class="card-actions">
                  <label>Agrupar por: </label>
                  <select class="form-control form-control-sm d-inline-block"
                          v-model="agrupamento"
                          style="width: 110px"
                          @change="buildEstatisticas()">
                    <option value="Dia">Dia</option>
                    <option value="Semana">Semana</option>
                    <option value="Quinzena">Quinzena</option>
                    <option value="Mes">Mês</option>
                    <option value="Semestre">Semestre</option>
                    <option value="Ano">Ano</option>
                  </select>
                </div>
                <h2 class="card-title">Evolução por data de emissão</h2>
                <p class="card-subtitle">Barras: valor total. Linhas: média por chassi (R$) e quantidade de chassis</p>
              </header>
              <div class="card-body">
                <div id="containerFornecedorEstatisticas"></div>
              </div>
            </section>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col-lg-12">
            <section class="card">
              <header class="card-header">
                <div class="card-actions">
                  <button class="btn btn-sm btn-default" @click="$root.exportCurrentTable()">
                    <i class="fas fa-file-excel" style="color:green"></i> Excel
                  </button>
                </div>
                <h2 class="card-title">Dados do fornecedor</h2>
              </header>
              <div class="card-body table-responsive">
                <table class="table table-sm table-hover table-striped table-bordered" id="report_table">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Chassi</th>
                      <th>Descrição</th>
                      <th>Classif.</th>
                      <th>Valor</th>
                      <th>Status</th>
                      <th>Cadastro</th>
                      <th>Dt. Status</th>
                      <th>Data prevista</th>
                      <th>Data da entrega</th>
                      <th>Tempo de atraso</th>
                      <th>Status entrega</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in data" :key="item.Id">
                      <td>
                        <a target="_blank" :href="'/veiculos?page=1&order=Id&direction=desc&requisicao='+item.Id">{{ item.Id }}</a>
                      </td>
                      <td>{{ item.Chassi }}</td>
                      <td>{{ item.Servico }}</td>
                      <td>{{ item.Classificacao }}</td>
                      <td>R$&nbsp;{{ $numero(valorLiquido(item)) }}</td>
                      <td>{{ item.Status }}</td>
                      <td>{{ item.DataDisplay }}</td>
                      <td>{{ item.DataSituacaoDisplay }}</td>
                      <td>{{ item.DataPrometidaDisplay || '-' }}</td>
                      <td>{{ item.DataExecucaoDisplay || '-' }}</td>
                      <td>{{ item.DiasAtraso ? item.DiasAtraso + ' dia(s)' : '-' }}</td>
                      <td>
                        <span :class="'badge badge-' + resolveStatusEntregaClass(item.Entrega)">{{ item.Entrega }}</span>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="4">Total</th>
                      <td colspan="8">R$&nbsp;{{ totalValorDisplay }}</td>
                    </tr>
                    <tr>
                      <th colspan="4">% atraso por chassi</th>
                      <td colspan="8">{{ percentualAtrasoChassi }}%</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </section>
          </div>
        </div>
        </template>
      </template>
    </div>
  </section>
</template>

<script>
import api from '@/services/api.js';
import {
    groupBy,
    toHighchartPieData,
    theme,
    distinct,
    periodoAgrupamento,
    ordenarPeriodos,
    resolveStatusEntregaClass
} from '@/services/helpers.js';

let dtIni30 = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0];
let dtIni90 = new Date(new Date().setDate(new Date().getDate() - 90)).toISOString().split('T')[0];
let dtIni180 = new Date(new Date().setDate(new Date().getDate() - 180)).toISOString().split('T')[0];
let dtIni365 = new Date(new Date().setDate(new Date().getDate() - 365)).toISOString().split('T')[0];
let dtFim = new Date().toISOString().split('T')[0];
var defaultOptions = $.extend(true, {}, Highcharts.getOptions(), {});

//Extrato do fornecedor: despesas abertas para um fornecedor dentro de um período.
export default {
    data() {
        return {
            fornecedor: null,
            fornecedores: [],
            data: [],
            dtRange: [
                { id: 'Últimos 30 dias', value: `${dtIni30}/${dtFim}` },
                { id: 'Últimos 3 meses', value: `${dtIni90}/${dtFim}` },
                { id: 'Últimos 6 meses', value: `${dtIni180}/${dtFim}` },
                { id: 'Últimos 12 meses', value: `${dtIni365}/${dtFim}` },
                { id: 'Customizado', value: `` }
            ],
            range: `${dtIni30}/${dtFim}`,
            inicio: dtIni30,
            fim: dtFim,
            agrupamento: 'Mes',
            //true depois da 1ª consulta - distingue "ainda não buscou" de "buscou e não achou nada"
            consultado: false
        };
    },
    computed: {
        totalValor: function () {
            return this.data.reduce((total, item) => total + this.valorLiquido(item), 0);
        },
        totalValorDisplay: function () {
            return numberWithCommas(this.totalValor);
        },
        /**
         * Qualidade da entrega: só as despesas que chegaram a ser enviadas ao fornecedor
         * (sem data de envio não há prazo a cobrar).
         */
        qualidade: function () {
            let enviadas = this.data.filter(d => d.DataEnvio);
            let entreguesNoPrazo = enviadas.filter(d => d.StatusEntrega === 3).length;
            let entreguesComAtraso = enviadas.filter(d => d.StatusEntrega === 4).length;
            let emAndamentoNoPrazo = enviadas.filter(d => d.StatusEntrega === 1).length;
            let emAtraso = enviadas.filter(d => d.StatusEntrega === 2).length;
            let atrasadas = entreguesComAtraso + emAtraso;

            return {
                chassis: enviadas.map(d => d.Chassi || d.Placa).filter(distinct).length,
                requisicoes: enviadas.length,
                noPrazo: entreguesNoPrazo + emAndamentoNoPrazo,
                atrasadas: atrasadas,
                entreguesNoPrazo: entreguesNoPrazo,
                entreguesComAtraso: entreguesComAtraso,
                emAndamentoNoPrazo: emAndamentoNoPrazo,
                emAtraso: emAtraso,
                percentualAtraso: enviadas.length ? ((atrasadas / enviadas.length) * 100).toFixed(1) : '0.0'
            };
        },
        /** Percentual de chassis que tiveram ao menos uma despesa atrasada. */
        percentualAtrasoChassi: function () {
            let chassis = this.data.map(d => d.Chassi || d.Placa).filter(distinct);
            if (!chassis.length) {
                return '0.0';
            }
            let comAtraso = chassis.filter(c =>
                this.data.some(d => (d.Chassi || d.Placa) === c && (d.StatusEntrega === 2 || d.StatusEntrega === 4)));
            return ((comAtraso.length / chassis.length) * 100).toFixed(1);
        }
    },
    methods: {
        resolveStatusEntregaClass: resolveStatusEntregaClass,
        /** Valor líquido (Valor - Desconto) já blindado contra null/undefined vindos da API. */
        valorLiquido: function (item) {
            return (item.Valor || 0) - (item.Desconto || 0);
        },
        /**
         * @input do v-select roda antes/depois do próprio v-model dependendo de como o Vue
         * mescla os dois listeners - por isso a consulta usa o valor do evento, não this.fornecedor.
         */
        onFornecedorInput: function (fornecedor) {
            this.fornecedor = fornecedor;
            this.data = [];
            this.consultado = false;
            if (fornecedor) {
                this.consultar();
            }
        },
        buscarFornecedor: function (search) {
            if (!search || search.length < 3) {
                return;
            }
            let that = this;
            api.get('/fornecedores/buscar?q=' + search)
                .then(response => {
                    that.fornecedores = response.data;
                });
        },
        changeRange: function () {
            if (!this.range) {
                return;
            }
            this.inicio = this.range.split('/')[0];
            this.fim = this.range.split('/')[1];
            this.consultar();
        },
        changeTextRange: function () {
            this.range = '';
            this.consultar();
        },
        consultar: function () {
            if (!this.fornecedor) {
                return;
            }
            let that = this;
            api.get(`/relatorios/dashboardfornecedor?fornecedorId=${this.fornecedor.Id}` +
                    `&dataIni=${escape(this.inicio)}&dataFim=${escape(this.fim)}`)
                .then(response => {
                    that.data = Array.isArray(response.data) ? response.data : [];
                    that.consultado = true;
                    that.$nextTick(() => that.build());
                });
        },
        build: function () {
            let data = this.data;

            for (let i in data) {
                data[i].DataRef = new Date(data[i].Data);
                data[i].DataDisplay = data[i].DataRef.toLocaleDateString('pt-BR');
            }

            if (!data.length) {
                return;
            }

            Highcharts.setOptions(theme);
            Highcharts.chart('containerFornecedorClassificacao', {
                chart: { type: 'pie', plotBackgroundColor: null, plotBorderWidth: null, plotShadow: false },
                title: { text: 'Geral por classificação' },
                tooltip: { pointFormat: '{series.name}: <b>{point.percentage:.1f}% <small>(R$ {point.valor})</small></b>' },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>: {point.percentage:.1f}% <small>(R$ {point.valor})</small>'
                        }
                    }
                },
                series: [{
                    name: 'Classificação',
                    colorByPoint: true,
                    data: toHighchartPieData(groupBy(data, 'Classificacao'))
                }]
            });
            Highcharts.setOptions(defaultOptions);

            this.buildEstatisticas();
        },
        /**
         * "Classifique pela data de emissão a quantidade de chassis e valores totais
         * gastos, e média por chassi" - as 3 métricas ficam juntas no mesmo gráfico,
         * não atrás de um seletor (por isso não há mais o dropdown "Medida").
         */
        buildEstatisticas: function () {
            let data = this.data;
            if (!data.length) {
                return;
            }

            for (let i in data) {
                data[i].Periodo = periodoAgrupamento(data[i].Data, this.agrupamento);
            }

            let grupos = groupBy(data, 'Periodo');
            let categories = ordenarPeriodos(grupos, 'Data');

            let valores = categories.map(c =>
                grupos[c].reduce((total, item) => total + this.valorLiquido(item), 0));
            let chassis = categories.map(c =>
                grupos[c].map(i => i.Chassi || i.Placa).filter(distinct).length);
            let medias = categories.map((c, i) =>
                chassis[i] ? parseFloat((valores[i] / chassis[i]).toFixed(2)) : 0);

            Highcharts.chart('containerFornecedorEstatisticas', {
                chart: { zoomType: 'xy' },
                title: { text: 'Estatísticas' },
                subtitle: { text: 'Agrupado por ' + this.agrupamento },
                xAxis: [{ categories: categories, crosshair: true }],
                yAxis: [
                    {
                        labels: { format: 'R$ {value}' },
                        title: { text: 'Valor (R$)' }
                    },
                    {
                        title: { text: 'Chassis' },
                        allowDecimals: false,
                        opposite: true
                    }
                ],
                plotOptions: { series: { dataLabels: { enabled: true } } },
                tooltip: { shared: true },
                series: [
                    {
                        name: 'Valor total',
                        data: valores,
                        type: 'column',
                        tooltip: { valuePrefix: 'R$ ' }
                    },
                    {
                        name: 'Média por chassi',
                        data: medias,
                        type: 'spline',
                        tooltip: { valuePrefix: 'R$ ' }
                    },
                    {
                        name: 'Quantidade de chassis',
                        data: chassis,
                        type: 'spline',
                        yAxis: 1
                    }
                ]
            });
        }
    },
    mounted: function () {
        document.title = 'Estoque Auto - Extrato do fornecedor';
    }
};
</script>
